import { shopManagerApi } from 'configs';
import api from 'configs/api';
import { convertToSearchCriteria } from 'helpers/api';
import {
  getGiftCodesListFailed,
  getGiftCodesListStart,
  getGiftCodesListSuccess,
  getSingleGiftCodeFailed,
  getSingleGiftCodeStart,
  getSingleGiftCodeSuccess,
  getGiftCardHistoryStart,
  getGiftCardHistorySuccess,
  getGiftCardHistoryFailed,
  getGiftCardTemplatesStart,
  getGiftCardTemplatesSuccess,
  getGiftCardTemplatesFailed,
  createGiftCardCodeStart,
  createGiftCardCodeSuccess,
  createGiftCardCodeFailed
} from 'redux/actions/gift_card';


export const getGiftCodesApi = async ({
  dispatch,
  sortDirection,
  sortField,
  pageSize,
  currentPage,
  searchConditions,
  filterConditions,
  isCSVData = false
}) => {
  try {
    dispatch(getGiftCodesListStart(isCSVData));
    const params = convertToSearchCriteria({
      searchConditions,
      filterConditions,
      pageSize,
      currentPage,
      sortField,
      sortDirection
    });
    const { data } = await api.get(`${shopManagerApi}/store/mpgiftcard/search?${params}`);
    dispatch(getGiftCodesListSuccess(data, isCSVData));
  } catch (e) {
    dispatch(getGiftCodesListFailed(e, isCSVData));
  }
};

export const getSingleGiftCodeApi = async ({
  dispatch,
  giftcardId
}) => {
  try {
    dispatch(getSingleGiftCodeStart());
    const params = convertToSearchCriteria({
      filterConditions: {
        customer_name: {
          field: 'giftcard_id',
          value: giftcardId,
          conditionType: 'eq'
        },
      }
    });
    const { data } = await api.get(`${shopManagerApi}/store/mpgiftcard/search?${params}`);
    dispatch(getSingleGiftCodeSuccess(data.giftCards?.items?.[0]));
  } catch (e) {
    dispatch(getSingleGiftCodeFailed(e));
  }
};

export const getSingleGiftCardHistoryApi = async ({
  dispatch,
  giftcardId
}) => {
  try {
    dispatch(getGiftCardHistoryStart());
    const params = convertToSearchCriteria({
      filterConditions: {
        customer_name: {
          field: 'giftcard_id',
          value: giftcardId,
          conditionType: 'eq'
        },
      }
    });
    const { data } = await api.get(`${shopManagerApi}/store/mpgiftcard/history/search?${params}`);
    dispatch(getGiftCardHistorySuccess(data));
  } catch (e) {
    dispatch(getGiftCardHistoryFailed(e));
  }
};

export const getGiftCardsHistoryApi = async ({
  dispatch,
  sortDirection,
  sortField,
  pageSize,
  currentPage,
  searchConditions,
  filterConditions
}) => {
  try {
    dispatch(getGiftCardHistoryStart());
    const params = convertToSearchCriteria({
      searchConditions,
      filterConditions,
      pageSize,
      currentPage,
      sortField,
      sortDirection
    });
    const { data } = await api.get(`${shopManagerApi}/store/mpgiftcard/history/search?${params}`);
    dispatch(getGiftCardHistorySuccess(data));
  } catch (e) {
    dispatch(getGiftCardHistoryFailed(e));
  }
};

export const getGiftCardTemplatesApi = async ({dispatch}) => {
  try {
    dispatch(getGiftCardTemplatesStart());
    const { data } = await api.get(`${shopManagerApi}/store/mpgiftcard/template/search?searchCriteria%5BcurrentPage%5D=1`);
    dispatch(getGiftCardTemplatesSuccess(data));
  } catch (e) {
    dispatch(getGiftCardTemplatesFailed(e));
  }
};

export const createGiftCardCodeApi = async ({dispatch, giftCardInfo}) => {
  try {
    dispatch(createGiftCardCodeStart());
    const { data } = await api.put(`${shopManagerApi}/store/mpgiftcard`, giftCardInfo);
    dispatch(createGiftCardCodeSuccess(data));
    return true;
  } catch (e) {
    dispatch(createGiftCardCodeFailed(e));
    return false;
  }
};
